import { ColumnData } from 'common/components/SearchBar';
import { ColumnActionsMode } from '@fluentui/react';
import { commonColumnProps } from 'common/utils/columnUtilities';

export const getColumns = () => {
  const columns: ColumnData[] = [
    {
      key: 'name',
      name: 'Name',
      fieldName: 'name',
      minWidth: 250,
      maxWidth: 250,
      ...commonColumnProps,
    },
    {
      key: 'description',
      name: 'Description',
      fieldName: 'description',
      minWidth: 150,
      maxWidth: 300,
      ...commonColumnProps,
    },
    {
      key: 'isAccessOnlyToCreatedRows',
      name: 'My Transactions Only',
      fieldName: 'isAccessOnlyToCreatedRows',
      minWidth: 200,
      maxWidth: 200,
      ...commonColumnProps,
    },
    {
      key: 'action',
      name: 'Actions',
      fieldName: 'action',
      minWidth: 50,
      columnActionsMode: ColumnActionsMode.disabled,
      ...commonColumnProps,
      isResizable: false,
    },
  ];
  return columns;
};
